import { FarrisCommonModule } from '@farris/ui-common';
import { FarrisLocalePipe } from './locale.pipe';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { LocaleService, FARRIS_LOCAL_CUSTOM_DATA } from './locale.service';



@NgModule({
  declarations: [
    FarrisLocalePipe
  ],
  imports: [
    FarrisCommonModule.forRoot()
  ],
  exports: [FarrisLocalePipe],
  providers: [
    LocaleService
  ]
})
export class LocaleModule {
  static forRoot(customData?: any): ModuleWithProviders {
    return {
        ngModule: LocaleModule,
        providers: [
          {provide: FARRIS_LOCAL_CUSTOM_DATA, useValue: customData || {}},
          LocaleService
        ]
    };
}
}
